import { toast as sonnerToast, type ExternalToast } from "sonner";

const APP_TOAST_ID = "app-toast";

type ToastMessage = Parameters<typeof sonnerToast>[0];

const withSharedId = (data?: ExternalToast): ExternalToast => ({ ...data, id: APP_TOAST_ID });

function appToast(message: ToastMessage, data?: ExternalToast) {
  return sonnerToast(message, withSharedId(data));
}

appToast.success = (message: ToastMessage, data?: ExternalToast) =>
  sonnerToast.success(message, withSharedId(data));

appToast.error = (message: ToastMessage, data?: ExternalToast) =>
  sonnerToast.error(message, withSharedId(data));

appToast.warning = (message: ToastMessage, data?: ExternalToast) =>
  sonnerToast.warning(message, withSharedId(data));

appToast.info = (message: ToastMessage, data?: ExternalToast) =>
  sonnerToast.info(message, withSharedId(data));

appToast.message = (message: ToastMessage, data?: ExternalToast) =>
  sonnerToast.message(message, withSharedId(data));

appToast.loading = (message: ToastMessage, data?: ExternalToast) =>
  sonnerToast.loading(message, withSharedId(data));

appToast.custom = sonnerToast.custom;
appToast.promise = sonnerToast.promise;
appToast.dismiss = sonnerToast.dismiss;

export const toast = appToast;
